import { useMemo } from 'react';
import { useProfileInfoContext } from 'contexts/profileInfo';

export const useGetSettleDescription = (claimNo: string) => {
  const { state: data } = useProfileInfoContext();
  return useMemo(() => {
    return data && `${data?.policyNumber} | ${data?.memberId} | ${claimNo}`;
  }, [data, claimNo]);
};
